import React, { createContext, useContext, useMemo, useState } from 'react'

const TableBranchContext = createContext(null)

const useSelectedTableBranch = () => {
  const context = useContext(TableBranchContext)
  if (!context) {
    throw new Error('useCount must be used within a TableBranchProvider')
  }
  return context
}

const SelectedTableBranchProvider = props => {
  const [selectedTableBranch, setSelectedTableBranch] = useState(null)

  const value = useMemo(() => ({ selectedTableBranch, setSelectedTableBranch }), [selectedTableBranch])
  return <TableBranchContext.Provider value={value} {...props} />
}

export { SelectedTableBranchProvider, useSelectedTableBranch }
